<template>
  <v-list height="22vh">
    <v-list-item-group v-if="tabData['can'] != null" class="pt-4">
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{FuelLevel}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['can']['fuelLevelPercentage'] }}%</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{FuelLevel}}(l)</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['can']['fuelLevelLiters'] }}L</v-list-item-subtitle>
      </v-list-item>
      <v-list-item v-if="tabData['can']['rpm']">
        <v-list-item-title class="text-caption font-weight-bold">{{ Rpm }}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['can']['rpm'] }}</v-list-item-subtitle>
      </v-list-item>
    </v-list-item-group>
    <v-list-item-group v-else>
    </v-list-item-group>
  </v-list>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
export default {
  props: {
    tabData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      FuelLevel: translate('Fuel level', 'realtimeMap'),
      Rpm: translate('Revolutions per minute', 'realtimeMap')
    }
  }
}
</script>

<style scoped>
.v-list-item {
  min-height: 22px;
}
</style>
